<template>
  <div>
    <PageAllow controller="PurchasePlans" action="addViews" />
    <Breadcrumbs :items="items" />

    <v-sheet class="transparent-background-color">
      <v-row dense class="mx-5">
        <v-col cols="12" sm="12" md="4">
          <v-row dense align="center" class="pa-1">
            <SearcherDatetimeRangeWithRadio
              v-model="options"
              type="datetime"
              show-radios
              :radios="datetimeRadios"
              deleteIcon
              removeIcon
            />
          </v-row>
        </v-col>
        <v-col cols="12" sm="12" md="8" align-self="center">
          <v-row dense align="center" class="search-controls">
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  v-bind="attrs"
                  v-on="on"
                  small
                  text
                  class="px-0 py-0 caption font-weight-bold grey--text"
                  color="primary"
                  @click.stop="onSearch()"
                >
                  <v-icon small class="pe-1">fa-search</v-icon>
                  {{ $t("Search.search") }}
                </v-btn>
              </template>
              <span>{{ $t("Search.searchTip") }}</span>
            </v-tooltip>
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  v-bind="attrs"
                  v-on="on"
                  small
                  text
                  class="caption font-weight-bold grey--text"
                  @click.stop="resetSearch()"
                >
                  <v-icon x-small class="pe-1">fa-trash-alt</v-icon>
                  {{ $t("Search.reset") }}
                </v-btn>
              </template>
              <span>{{ $t("Search.resetTip") }}</span>
            </v-tooltip>
            <v-divider vertical />
            <v-btn
              class="caption font-weight-bold grey--text"
              :class="
                $vuetify.theme.dark ? 'text--lighten-1' : 'text--darken-1'
              "
              small
              text
              @click.stop="$store.commit('toggleSearchPanel')"
            >
              {{ $t("Search.pro") }}
              <v-icon small class="ps-1">{{
                $store.state.showSearchPanel ? "fa-angle-up" : "fa-angle-down"
              }}</v-icon>
            </v-btn>
            <v-spacer />
            <v-btn
              v-if="
                $permission.permissionAllow(
                  'PurchasePlans',
                  'getPurchaseableDetails'
                )
              "
              small
              color="primary"
              class="elevation-1 ms-1"
              width="110px"
              :disabled="!showSelected.length"
              @click="submit()"
            >
              {{ $t("PurchasePlans.create.next") }}
            </v-btn>
          </v-row>
        </v-col>
      </v-row>
      <v-expansion-panels
        v-model="$store.getters.panels"
        multiple
        flat
        accordion
      >
        <v-expansion-panel class="transparent-background-color">
          <v-expansion-panel-content>
            <v-row dense align="center">
              <v-col cols="12" sm="6" md="4">
                <SearcherKeyword
                  ref="stock_order_code"
                  v-model="options.stock_order_code"
                  @text="stockOutsKeyWord = $event"
                  :label="$t('PurchasePlans.Fields.stockOutsKeyword_two')"
                />
              </v-col>
              <!-- 仓库 -->
              <v-col cols="12" sm="6" md="4">
                <SearcherStock :stockTypes="[0]" v-model="stockSelected" />
              </v-col>
              <!-- 客户 -->
              <v-col cols="12" sm="6" md="4">
                <SearcherShops v-model="shopsSelected" />
              </v-col>
              <!-- 配送点 -->
              <v-col
                cols="12"
                sm="6"
                md="4"
                v-if="
                  settings &&
                  settings.delivery_point &&
                  $permission.permissionAllow('DeliveryPoints', 'index')
                "
              >
                <SearcherDeliveryPoint v-model="deliveryPointSelected" />
              </v-col>
              <v-col cols="12" md="4" sm="4">
                <SearcherSupplier v-model="supplierSelected" />
              </v-col>
              <v-col cols="12" sm="6" md="4">
                <SearcherMaterials v-model="materialSelected" />
              </v-col>
              <v-col cols="12" sm="6" md="4">
                <v-select
                  v-model="outTypeSelected"
                  :items="
                    $consts.stock_out_order.types.filter(
                      (element) => (element.value == 1) || (element.value == 2) || (element.value == 4)
                    )
                  "
                  :label="$t('StockOrderOUT.Fields.stock_out_type')"
                  chips
                  multiple
                  clearable
                  deletable-chips
                  small-chips
                ></v-select>
              </v-col>
              <v-col cols="12" sm="6" md="4">
                <SearcherStatus
                  :label="$t('financeBills.payFlgs.title')"
                  :items="$consts.financeFlgs"
                  v-model="options.pay_flgs"
                />
              </v-col>
              <v-col
                cols="12"
                sm="6"
                md="4"
                v-if="
                  $permission.permissionAllow('PresaleTemplates', 'index') &&
                  settings &&
                  settings.presale_enable
                "
              >
                <SearcherStatus
                  v-model="options.presale_flgs"
                  :label="$t('Order.presale_flgs.title')"
                  :items="$consts.order.presale_flg"
                />
              </v-col>
              <v-col cols="12" class="d-flex mt-2">
                <SearcherStatus
                  v-model="parameter.is_stock_current"
                  :items="[
                    {
                      text: $t('PurchasePlans.autoRuler.is_stock_current'),
                      color: 'primary',
                      textColor: 'white',
                      value: 1,
                    },
                  ]"
                />
                <SearcherStatus
                  v-model="parameter.is_purchased"
                  :items="[
                    {
                      text: $t('PurchasePlans.is_purchased'),
                      color: 'primary',
                      textColor: 'white',
                      value: 1,
                    },
                  ]"
                />
                <SearcherStatus
                  v-model="parameter.is_loss"
                  :items="[
                    {
                      text: $t('PurchasePlans.is_loss'),
                      color: 'primary',
                      textColor: 'white',
                      value: 1,
                    },
                  ]"
                />
                <v-spacer />
              </v-col>
            </v-row>
          </v-expansion-panel-content>
        </v-expansion-panel>
      </v-expansion-panels>
      <div class="mx-4 my-4">
        <v-data-table
          v-model="showSelected"
          id="purchase_from_order_table"
          :headers="headers"
          class="elevation-2 pa-4 mt-4"
          :items="stockOuts"
          show-select
          item-key="id"
          disable-sort
          :options.sync="options"
          :page.sync="paging.page"
          :server-items-length="paging.count"
          :footer-props="footerProps"
          :loading="loading"
        >
          <template v-slot:item.created="{ item }">
            {{ item.created | formatTime }}
          </template>
        </v-data-table>
      </div>
    </v-sheet>
  </div>
</template>

<script>
import { mapState } from "vuex";
import i18n from "@/i18n";
import PageAllow from "@/components/PageAllow";
import Breadcrumbs from "@/components/Breadcrumbs";
import StockOuts from "@/api/stock_outs";
import SearcherDatetimeRangeWithRadio from "@/components/plugins/SearcherDatetimeRangeWithRadio";
import SearcherKeyword from "@/components/plugins/SearcherKeyword";
import SearcherDeliveryPoint from "@/components/plugins/SearcherDeliveryPoint";
import SearcherStock from "@/components/plugins/SearcherStock";
import SearcherShops from "@/components/plugins/SearcherShops";
import SearcherStatus from "@/components/plugins/SearcherStatus";
import SearcherSupplier from "@/components/plugins/SearcherSupplier";
import SearcherMaterials from "@/components/plugins/SearcherMaterials";

const defaultOptions = {
  datetimeRadioSelected: "created",
  created_time_from:
    new Date(new Date().getTime() - 30 * 24 * 3600 * 1000)
      .toISOString()
      .substr(0, 10) + " 00:00:00",
  created_time_to: new Date().toISOString().substr(0, 10) + " 23:59:59",
  order_time_from: "",
  order_time_to: "",
  actual_time_from: "",
  actual_time_to: "",
  expect_time_from: "",
  expect_time_to: "",
  stock_order_code: "",
  stock_ids: null,
  shop_ids: [],
  cancel_flgs: [0],
  is_purchase_plan: [0],
  delivery_point_id: null,
  type: [1, 2],
  status: [2],
  pay_flgs: [],
  material_ids: [],
  presale_flgs: [0, 1],
  purchase_plan_supplier_id: null,
  real_stock_flg: 1,
  is_requested: [0],
};

const defaultParameter = {
  is_stock_current: [],
  is_purchased: [],
  is_loss: [],
};

export default {
  components: {
    PageAllow,
    Breadcrumbs,
    SearcherDatetimeRangeWithRadio,
    SearcherKeyword,
    SearcherDeliveryPoint,
    SearcherStock,
    SearcherShops,
    SearcherStatus,
    SearcherSupplier,
    SearcherMaterials,
  },

  computed: {
    items() {
      let items = [
        {
          text: i18n.t("Nav.home"),
          disabled: false,
          href: "/home",
        },
        {
          text: i18n.t("Nav.purchases"),
          disabled: false,
          href: "/purchases",
        },
        {
          text: i18n.t("Nav.purchasePlans"),
          disabled: false,
          href: "/purchase-plans",
        },
        {
          text: i18n.t("PurchasePlans.create.title"),
          disabled: true,
          href: "/purchase-plans",
        },
      ];
      return items;
    },

    headers() {
      let headers = [
        {
          text: i18n.t("PurchasePlans.Fields.stock_out_code"),
          align: "start",
          sortable: false,
          value: "stock_order_code",
        },
        {
          text: i18n.t("PurchasePlans.Fields.stock_out_obj_name"),
          align: "start",
          class: "text-no-wrap",
          sortable: false,
          value: "obj_name",
        },
        {
          text: i18n.t("PurchasePlans.Fields.order_code"),
          align: "start",
          value: "order_code",
        },
        {
          text: i18n.t("PurchasePlans.Fields.out_type_str"),
          align: "start",
          value: "out_type_str",
        },
        {
          text: i18n.t("PurchasePlans.Fields.stock_name"),
          align: "start",
          sortable: false,
          value: "stock.name",
        },
        {
          text: i18n.t("PurchasePlans.Fields.created"),
          align: "start",
          value: "created",
        },
      ];
      return headers;
    },

    datetimeRadios: () => [
      {
        key: "created",
        text: i18n.t("StockOrderOUT.Fields.created_time"),
      },
      {
        key: "order",
        text: i18n.t("StockOrderOUT.Fields.order_time"),
      },
      {
        key: "actual",
        text: i18n.t("StockOrderOUT.Fields.actual_time"),
      },
      {
        key: "expect",
        text: i18n.t("StockOrderOUT.Fields.expect_time"),
      },
    ],
    footerProps() {
      let props = Object.assign({}, i18n.t("$config.footer-props"));
      props.itemsPerPageOptions = [...props.itemsPerPageOptions, -1];
      return props;
    },
    // 使用对象展开运算符将此对象混入到外部对象中
    ...mapState(["settings"]),
  },

  data: () => ({
    stockOuts: [],
    paging: {},
    showSelected: [],
    options: JSON.parse(JSON.stringify(defaultOptions)),
    parameter: JSON.parse(
      sessionStorage.getItem("purchase-plans-stock-outs-parameter")
        ? sessionStorage.getItem("purchase-plans-stock-outs-parameter")
        : JSON.stringify(defaultParameter)
    ),
    stockOutsKeyWord: "",
    supplierSelected: null,
    materialSelected: [],
    outTypeSelected: [],
    deliveryPointSelected: null,
    stockSelected: null,
    shopsSelected: null,
    loading: false,
  }),

  mounted() {
    let parameterStr = sessionStorage.getItem(
      "purchase-plans-stock-outs-parameter"
    );
    if (
      typeof parameterStr != "undefined" &&
      parameterStr != null &&
      parameterStr != "null"
    ) {
      this.parameter = JSON.parse(parameterStr);
    }
  },

  methods: {
    resetSearch() {
      this.stockOutsKeyWord = "";
      this.stockSelected = null;
      this.shopsSelected = null;
      this.supplierSelected = null;
      this.materialSelected = [];
      this.outTypeSelected = [];
      this.deliveryPointSelected = null;
      this.options = JSON.parse(JSON.stringify(defaultOptions));
      this.parameter = JSON.parse(JSON.stringify(defaultParameter));
      [this.$refs.stock_order_code].forEach((k) => {
        if (k) k.clear();
      });
    },
    onSearch() {
      this.options = Object.assign({}, this.options, {
        stock_order_code: this.stockOutsKeyWord,
      });
    },
    getStockOutsFromAPI() {
      this.loading = true;
      let options = Object.assign({}, this.options, {
        itemsPerPage:
          this.options.itemsPerPage == -1
            ? this.$consts.limitAll
            : this.options.itemsPerPage,
      });
      if (this.outTypeSelected == [] || this.outTypeSelected.length == 0) {
        options.type = [1, 2]
      }

      StockOuts.fetch(options).then(
        function (response) {
          if (response.data.status.isOK()) {
            this.stockOuts = response.data.stock_outs;
            this.paging = response.data.paging;
          } else if (response.data.error.code.isNoResultSet()) {
            this.options.page = 1;
          }
          this.loading = false;
        }.bind(this)
      );
    },
    submit() {
      if (this.showSelected.length) {
        var stockOrderIds = this.showSelected.map((s) => {
          return s.id;
        });
        let query = {
          ids: stockOrderIds,
        };
        if (this.supplierSelected) {
          query.supplierId = this.supplierSelected.id;
        }
        if (this.materialSelected) {
          query.materialIds = this.materialSelected.map((e) => {
            return e.id;
          });
        }
        this.$router.push({
          path: "/purchase-plans/purchase-plans-create",
          query: query,
        });
      }
    },
  },

  watch: {
    options: {
      deep: true,
      handler() {
        this.getStockOutsFromAPI();
      },
    },
    parameter: {
      deep: true,
      handler() {
        sessionStorage.setItem(
          "purchase-plans-stock-outs-parameter",
          JSON.stringify(this.parameter)
        );
      },
    },
    stockSelected: {
      handler() {
        this.options.stock_ids = this.stockSelected
          ? this.stockSelected.id
          : null;
      },
    },
    shopsSelected: {
      handler() {
        this.options.shop_ids = this.shopsSelected
          ? this.shopsSelected.map((shop) => {
              return shop.id;
            })
          : [];
      },
    },
    deliveryPointSelected: {
      handler() {
        this.options.delivery_point_id = this.deliveryPointSelected
          ? this.deliveryPointSelected.id
          : null;
      },
    },
    supplierSelected: {
      handler() {
        this.options.purchase_plan_supplier_id = this.supplierSelected
          ? this.supplierSelected.id
          : null;
      },
    },
    materialSelected: {
      handler() {
        this.options.material_ids = this.materialSelected
          ? this.materialSelected.map((e) => {
              return e.id;
            })
          : [];
      },
    },
    outTypeSelected: {
      handler() {
        this.options.type = this.outTypeSelected
          ? this.outTypeSelected.map((e) => {
            return e;
          })
          : [];
      }
    },
  },
};
</script>